/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { devopsConnectedProjectRoute } from '@jira/router-routes__devops-connected-project-routes/src/devopsConnectedProjectRoute.tsx';
import DevopsConnectedProject, {
	LazyDevopsConnectedProject,
} from './ui/spa/devops/connected-project/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const devopsConnectedProjectRouteEntry: Route = createEntry(
	devopsConnectedProjectRoute,
	() => ({
		group: 'devops',
		ufoName: 'devops.connected-project',
		// eslint-disable-next-line no-restricted-syntax
		component: DevopsConnectedProject,
		layout: chromelessLayout,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyDevopsConnectedProject],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
